import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    details: [],
  },
  getters: {
    details: (state) => state.details,
  },
  actions: {
    fetchSingle({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax.get('CMS/api/AdvertisingCampaignQuery/' + id).then(r => {
          commit('setDetails', r.data);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
  }
}
